/** @format */

import $ from "jquery";

let activeClass = "header__strip__link--active";
let menuIcon = $("[data-show-menu]");
let mobileMenu = $("[data-mobile-menu]");

menuIcon.on("click", () => {
    if (menuIcon.is(`.${activeClass}`)) {
        menuIcon.removeClass(activeClass);
        mobileMenu.fadeOut();
    } else {
        menuIcon.addClass(activeClass);
        mobileMenu.fadeIn();
    }
});

let carouselElem = document.querySelector(
    "[data-carousel-container]"
) as HTMLElement;

if (carouselElem) {
    import("./carousel").then(carousel => {
        carousel.setup(carouselElem);
    });
}

if (document.querySelector("[data-faq-question]")) {
    import("./faqs").then(faqs => {
        faqs.setup();
    });
}

let wbavForm = $("[data-wbav-form]");

if (wbavForm.length) {
    import("./wbav").then(wbav => {
        wbav.setup(wbavForm);
    });
}
